<template>
  <div>
    <h3 v-if="showOutterLabel" class="mb-3">
      {{ label }}
    </h3>
    <v-autocomplete
      @change="handleSelect"
      :no-data-text="$t('table.noResults')"
      :value="value"
      :items="appointmentTypes"
      :label="label"
      :loading="isLoading"
      :multiple="multiple"
      :rules="rules"
      :dense="dense"
      :item-text="(item) => $t(`type.${item.value}`)"
      item-value="value"
      clearable
      outlined
    >
      <template v-slot:selection="data">
        <v-chip class="my-2">
          <v-avatar>
            <v-img width="24" height="24" v-html="handleGetIcon(data.item.value)" />
          </v-avatar>
          <span class="ml-2">
            {{ $t(`type.${data.item.value}`) }}
          </span>
        </v-chip>
      </template>
      <template slot="item" slot-scope="data">
        <div class="d-flex">
          <v-img class="mr-4" width="24" height="24" v-html="handleGetIcon(data.item.value)" />
          {{ $t(`type.${data.item.value}`) }}
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { icons } from '@/util/iconsSVG'
export default {
  name: "AdminServiceTypeSelect",
  props: {
    label: {
      type: String,
    },
    rules: {
      type: Array,
    },
    showOutterLabel: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    dense: {
      default: false,
    },
    value: [Array, String],
  },

  computed: {
    ...mapGetters(['isLoading', 'appointmentTypes']),

    hasMultipleServiceTypes() {
      return this.services && this.services.length > 1
    },
  },

  methods: {
    ...mapActions(['fetchAppointmentTypeAsAdmin']),
    handleSelect(value) {
      this.$emit('input', value)
    },
    handleGetIcon(type) {
      return icons[type]
    },
  },

  mounted() {
    this.fetchAppointmentTypeAsAdmin()
  },
}
</script>
